import type * as React from "react"

import { cn } from "@/lib/utils"

export interface UnderlineInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /** When true, do not auto-select the full value on focus. */
  disableAutoSelect?: boolean
}

/** Single-line input that looks like an underline field */
export function UnderlineInput(props: UnderlineInputProps) {
  const { className, onFocus, disableAutoSelect, ...rest } = props
  const isReadOnlyLike = Boolean(rest.readOnly || rest.disabled)

  const handleFocus: React.FocusEventHandler<HTMLInputElement> = (event) => {
    if (!disableAutoSelect) {
      try {
        event.currentTarget.select()
      } catch {
        // Some input types (e.g. date) do not support select()
      }
    }
    if (onFocus) {
      onFocus(event)
    }
  }

  return (
    <input
      {...rest}
      onFocus={handleFocus}
      className={cn(
        "jc-no-ios-zoom",
        "w-full text-sm text-slate-900 outline-none",
        isReadOnlyLike
          ? "rounded-md bg-slate-100 px-2 py-1 text-slate-600 shadow-[0_1px_0_0_rgba(203,213,225,1)]"
          : "bg-transparent shadow-[0_1px_0_0_rgba(148,163,184,1)] focus:shadow-[0_1px_0_0_rgba(15,23,42,1)]",
        className,
      )}
    />
  )
}
